interface StatsTeamHeaderProps {
	divisionSkillFrom: number;
	divisionSkillTo: number;
	divisionAgeFrom: number;
	divisionAgeTo: number;
	team: string;
	teamCaptain: string;
}

export const StatsTeamHeader = ({ divisionSkillFrom, divisionSkillTo, divisionAgeFrom, divisionAgeTo, team, teamCaptain }: StatsTeamHeaderProps) => {
	return (
		<div className="flex w-full flex-col gap-2 px-3 pt-2 sm:px-6 sm:pt-4">
			<h1 className="text-lg font-bold leading-7 text-gray-900">
				Division - Skill: {divisionSkillFrom}.{divisionSkillTo} | Age {divisionAgeFrom} - {divisionAgeTo}
			</h1>
			<h2 className="text-base font-bold leading-6 text-darkorange-400">{team}</h2>
			<p className="text-sm font-normal leading-5 text-gray-500">Captain: {teamCaptain}</p>
		</div>
	);
};
